<template>

  <div class="custom-table">
    <vxe-table border show-overflow ref="xTable" style="max-height: 400px;overflow-y: auto;" :data="tableData">
      <vxe-table-column type="seq" width="50" align="center" title="序号">
      </vxe-table-column>
      <vxe-table-column field="afterSeriesCode" align="center" title="变更后产品系列编码">
      </vxe-table-column>
      <vxe-table-column field="afterSeriesName" align="center" title="变更后产品系列名称">
      </vxe-table-column>
    </vxe-table>
  </div>

</template>

<script>

export default {
  props: {
    value: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.tableData = v || [];
        }
      },
    },
  },
  methods: {
  },

};
</script>

<style>

</style>
